module.exports = __webpack_public_path__ + "img/icon-letter-c.1b5a0c87.svg";